import React from "react";
import * as IMAGES from "../../Assets/Images";
import { Button } from "@material-ui/core";

import "./DataNotFound.css";

class DataNotFound extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  goToCatalogue = () => {
    this.props.history.push("/catalogue");
  };

  render = () => {
    return (
      <div className="cat-not-found">
        <img
          src={IMAGES.ITEM_NOT_FOUND}
          className="cat-not-found-image"
          alt="Category not found"
        />
        <div className="cat-not-found-heading">
          Seems like you want something that is unavailable in our menu.
        </div>
        <div className="cat-not-found-heading">
          Meanwhile you can have a look in our catalogue.
        </div>
        <Button
          color="primary"
          variant="contained"
          onClick={(e) => this.goToCatalogue()}
        >
          <div className="font-monst-bold">Catalogue</div>
        </Button>
      </div>
    );
  };
}

export default DataNotFound;
